import { render, staticRenderFns } from "./studentRecordDetailTopBar.vue?vue&type=template&id=09f1d446&scoped=true"
import script from "./studentRecordDetailTopBar.vue?vue&type=script&lang=js"
export * from "./studentRecordDetailTopBar.vue?vue&type=script&lang=js"
import style0 from "./studentRecordDetailTopBar.vue?vue&type=style&index=0&id=09f1d446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f1d446",
  null
  
)

export default component.exports